import React from 'react';
import PropTypes from 'prop-types';
import {useDispatch, useSelector} from 'react-redux';
import RadioButtonGroup from 'common/radio-button-group';
import {setTerm} from 'store/search-request/search-request-actions';

function SearchTermToggle({includeAirport, includeEvent, isSearching}) {
    const dispatch = useDispatch();
    const {
        city: {data: city},
        destination: {data: destination},
        searchRequest: {monthly: isMonthly, airport: isAirport, event: isEvent},
    } = useSelector(state => state);

    const onChange = ({value}) => {
        dispatch(
            setTerm({
                term: value,
                city,
                destination,
            })
        );
    };

    const hourlyItem = {
        label: 'Hourly',
        value: 'daily',
        checked: !isMonthly && !isAirport,
    };

    const monthlyItem = {
        label: 'Monthly',
        value: 'monthly',
        checked: isMonthly && !isAirport,
    };

    const items = [hourlyItem, monthlyItem];

    if (includeAirport) {
        items.push({
            label: 'Airport',
            value: 'airport',
            checked: isAirport,
        });
    }

    if (includeEvent) {
        hourlyItem.checked = !isMonthly && !isAirport && !isEvent;
        monthlyItem.checked = isMonthly && !isAirport && !isEvent;
        items.unshift({
            label: 'Event',
            value: 'event',
            checked: isEvent,
        });
    }

    return (
        <RadioButtonGroup
            className="SearchTermToggle"
            color="secondary"
            initialItems={items}
            disabled={isSearching}
            onChange={onChange}
        />
    );
}

SearchTermToggle.propTypes = {
    includeAirport: PropTypes.bool,
    includeEvent: PropTypes.bool,
    isSearching: PropTypes.bool,
};

export default SearchTermToggle;
